import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function UserChart({ verifyData }) {
  const data = {
    labels: [
      `Verified Users ${verifyData?.verified}`,
      `Unverified Users ${verifyData?.unverified}`,
    ],
    datasets: [
      {
        // label: "# of Votes",
        data: [verifyData?.verified, verifyData?.unverified],
        backgroundColor: ["#6DBBFA", "#00D89D"],
        borderColor: ["#6DBBFA", "#00D89D "],
        borderWidth: 1,
      },
    ],
  };

  return <Doughnut className="gender-chart" data={data} />;
}
